import {View, Pressable, StyleSheet} from 'react-native';
import colors from 'theme/Colors';
import {spacing} from 'theme/Units';
import React, {useState} from 'react';

type ToggleButtonProps = Readonly<{
  onToggle?: (isEnabled: boolean) => void;
  value?: boolean;
  sync?: boolean;
}>;

export function ToggleButton(props: ToggleButtonProps) {
  const {onToggle, value, sync = false} = props;
  const [isEnabled, setIsEnabled] = useState(value ?? false);
  const handleToggle = () => {
    const newState = !isEnabled;
    if (!sync) {
      setIsEnabled(newState);
    }
    onToggle?.(newState);
  };

  return (
    <Pressable
      style={[styles.button, isEnabled ? styles.enable : styles.disable]}
      onPress={handleToggle}>
      <View
        style={[
          styles.circle,
          {transform: [{translateX: isEnabled ? spacing['4'] : 0}]},
        ]}
      />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    width: spacing[9],
    height: spacing[5],
    borderRadius: 24,
    padding: 2,
  },
  enable: {
    backgroundColor: colors.palette.brandBlue,
  },
  disable: {
    backgroundColor: colors.palette.stroke,
  },
  circle: {
    width: spacing[4],
    height: spacing[4],
    backgroundColor: colors.palette.white,
    borderRadius: 100,
  },
});
